import { render, staticRenderFns } from "./SSSTable.vue?vue&type=template&id=dc0c5b8a&scoped=true"
import script from "./SSSTable.vue?vue&type=script&lang=js"
export * from "./SSSTable.vue?vue&type=script&lang=js"
import style0 from "./SSSTable.vue?vue&type=style&index=0&id=dc0c5b8a&prod&lang=css&scoped=true"
import style1 from "./SSSTable.vue?vue&type=style&index=1&id=dc0c5b8a&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc0c5b8a",
  null
  
)

export default component.exports